import css from 'styled-jsx/css';

const styles = css.global`#boleto-conteudos {
    background-color: #fbfbfb;
    padding-bottom: 40px;
  }
  
  #boleto-conteudos .is-desk {
    display: none;
  }
  
  #boleto-conteudos .is-mobi {
    overflow: hidden;
  }
  
  #boleto-conteudos .ctn-home-24 {
    position: relative;
  }
  
  #boleto-conteudos .boleto-conteudos-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin-bottom: 16px;
  }
  
  #boleto-conteudos .boleto-conteudos-slide {
    display: flex;
    justify-content: center;
    margin-right: 16px;
    margin-left: 0;
    flex: 0 0 272px;
  }
  
  #boleto-conteudos .boleto-conteudos-card {
    display: flex;
    flex-direction: column;
    color: #fff;
    width: 272px;
    min-height: 348px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #CCC;
  }
  
  #boleto-conteudos img {
    width: 100%;
    height: 189px;
    object-fit: cover;
    border-radius: 4px;
  }
  
  #boleto-conteudos .boleto-conteudos-card picture {
    width: 100%;
  }
  
  #boleto-conteudos .boleto-conteudos-card-textos {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 160px;
    padding: 8px 16px 11px;
  }
  
  #boleto-conteudos .boleto-conteudos-slide-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    margin: 0;
  }
  
  #boleto-conteudos .boleto-conteudos-slide-link {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  
  #boleto-conteudos .custom-carousel.embla {
    margin-bottom: 18px;
  }
  
  
  #boleto-conteudos .home-pagination {
    width: 100%;
    max-width: 288px;
    margin-left: auto;
    margin-right: auto;
  }
  
  #boleto-conteudos .home-pagination .enable-mobile-arrows {
    height: 24px;
    width: 24px;
    background-size: 24px 24px;
  }
  
  @media (min-width: 992px) {
  
    #boleto-conteudos { 
      padding-top: 88px;
      padding-bottom: 88px;
    }
  
    #boleto-conteudos .is-mobi {
      display: none;
    }
  
    #boleto-conteudos .is-desk {
      display: flex;
      flex-direction: column;
      position: relative;
      margin: auto;
    }
  
    #boleto-conteudos .cards-desk {
      display: flex;
      justify-content: space-between;
    }
  
    #boleto-conteudos .boleto-conteudos-card {
      width: 100%;
        max-width: 379px;
    }
  
    #boleto-conteudos .boleto-conteudos-card-textos {
      padding: 8px 16px 32px;
      height: 178px;
    }
  
  }`;

export default styles;